import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next'
import { PAYMENT_GATEWAY, CARD_CAN_BE_CHARGED, DEMO, CARD_DEMO, CMSPath } from '../../../../config/constant';
import Loader from '../../../UI/loader';
import clientConfigApi from '../../../../config/config';
import { setCardStatusPopupProps, setCheckinCurrentPageName } from '../../../action/autoCheckin';
import { popupOpenClose, setCheckInAddress, setShowCustomPopup } from "../../../../action/action";
import { sendAnalytics } from "../../../../action/homeAction"
import { getDefaultAnalyticsLabel } from '../../../JS/utility';
import $ from "jquery";
import { th } from 'date-fns/locale';
import Select from 'react-select';
import { scrollToTop } from '../../../../JS/scrollToTop';
import { getExpirationDateObject, handleExpirationDate } from './assets/js/expirationdate';
import { cardValidationIntermediaryEvents } from '../helper';

const splitFirstAndLastName=(fullName)=>{
    const trimmedFullName= fullName.trim();
    const indexToBreak= trimmedFullName.indexOf(" ");
    if(indexToBreak>0){
        return [trimmedFullName.slice(0,indexToBreak), trimmedFullName.slice(indexToBreak+1)];
    }else{
        return [trimmedFullName,""];
    }
}


class Planet extends Component {

    constructor(props) {
        super(props)
        this.state = {
            loaderInfo : {show: false, msg: ""},
            popupInfo : {show: false, msg:"" , primaryButtonText:"", handlePrimaryButton: null},
            iframeInfo : {show: false, loading: false},
            transactionId: null,
            verifyAttempts: 0,
            cardHolderDetails:{
                name:{value:"", errorMsg: null},
                email:{value:"", errorMsg: null},
                address:{value:"", errorMsg: null},
                pincode:{value:"", errorMsg: null},
                expiry:{value:"", errorMsg:null},
                cvv: { errorMsg: null},
                cardNumber: { errorMsg: null},
                cardTypeCode:null
            },
            hasPlanetScriptLoaded: false
        }

        this.iframeRef = React.createRef();
        this.handleMessageEvent = this.handleMessageEvent.bind(this);
        window.addEventListener("message", this.handleMessageEvent);
    }


    async loadDatatransScript(){
        if(this.state.hasPlanetScriptLoaded) return;

        console.log("inside loadDatatransScript")
        return new Promise((res, rej)=>{
        const script = document.createElement("script");
        script.src = (CARD_DEMO) ?
                        "https://pay.sandbox.datatrans.com/upp/payment/js/secure-fields-2.0.0.min.js"
                    : "https://pay.datatrans.com/upp/payment/js/secure-fields-2.0.0.min.js";
        script.onload = ()=> { this.setState({hasPlanetScriptLoaded:true}); res()};
        document.head.appendChild(script);    
        })
        
    }

    sendIntermediaryCardValidationGA = (subAction, responseFromPlanet = {}, additionalFields = {} )=>{
    
        let label = {
            "subAction":subAction,
            ...getDefaultAnalyticsLabel({appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : ""}),
            "dateTime": new Date,
            "layoutTab": this.props.currentHomePage.tabName,
            "pageName": "CREDIT CARD DETAILS",
            "widgetSessionId": localStorage.getItem("checkinSessionToken"),
             ...additionalFields
        }

        this.props.sendAnalytics(
            null, 
            this.props.currentWidgetObj.widgetType || "Mobile Check-in", 
            "CREDIT CARD DETAILS - IN PROGRESS", 
            label, 
            0, 
            false
        );
    
    }

    performChecksCall = (transactionId) => {
            console.log("inside performChecksCall", transactionId)

            this.setState({ loaderInfo : {show: true, msg: "Validating..."}, })

            clientConfigApi.post("/mobileCheckIn/cardValidation", {
                "header": {
                    "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                    "actionKey": "checks"
                },
                "payload": {
                    "confirmationNumber": this.props.confirmationNumber,
                    "firstNameCard": splitFirstAndLastName(this.state.cardHolderDetails.name.value)[0],
                    "lastNameCard":  splitFirstAndLastName(this.state.cardHolderDetails.name.value)[1],
                    "cardFullName": this.state.cardHolderDetails.name.value,
                    "developmentEnvironment": CARD_DEMO ? true : undefined,
                    "transactionId": this.state.transactionId,
                    //"cardCheckId": "xyz"
                }
            })
                .then((resp) => {
                    if(resp.status !=200)  throw resp;
                    if(!(resp && resp.data && resp.data.header && resp.data.header.status && resp.data.header.status.code == "SUCCESS")) throw resp;

                    console.log("checks call got success")
                    this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CHECKS_API_SUCCESS)
                    
                    this.setState({ loaderInfo : {show: true, msg: "Updating..."}, })
                    clientConfigApi.post("/mobileCheckIn/cardValidation", {
                        "header": {
                            "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                            "actionKey": "cardUpdate"
                        },
                        "payload": {
                            "confirmationNumber": this.props.confirmationNumber,
                            "firstNameCard": splitFirstAndLastName(this.state.cardHolderDetails.name.value)[0],
                            "lastNameCard":  splitFirstAndLastName(this.state.cardHolderDetails.name.value)[1],
                            "cardFullName": this.state.cardHolderDetails.name.value,
                            "developmentEnvironment": CARD_DEMO ? true : undefined,
                            "transactionId": this.state.transactionId,
                            "expiryDate": String(this.state.cardHolderDetails.expiry.value).replaceAll(" ","").replaceAll("/",""),
                            "cardTypeCode": this.state.cardTypeCode
                        }
                    })
                    .then((res) => {
                        if(res.status !=200) throw res;
                        if(!(res && res.data && res.data.header && res.data.header.status && res.data.header.status.code == "SUCCESS")) throw res;
                        
                        console.log("cardUpdate call got success", res)
                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CARD_UPDATE_API_SUCCESS)

                        this.props.setCardStatusPopupProps({
                            cardStatus: true,
                            statusTitle: 'Success',
                            statusMessage1: 'Card verified successfully',
                            statusMessage2: 'Please proceed to next steps'
                        })
                        this.props.showCardVerified({ address: this.state.cardHolderDetails.address.value, email: this.state.cardHolderDetails.email.value })
                        this.props.setcardVerified();
                        localStorage.setItem("cardVerfied", true)

                        // Send Analytics
                        let label = {
                            "dateTime": new Date,
                            "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                            "Room": localStorage.getItem("room") || "",
                            "sourceApp": "guestJourneyApp",
                            "layoutTab": this.props.currentHomePage.tabName,
                            "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                        }
                        this.props.sendAnalytics(
                            null,
                            this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                            "CREDIT CARD DETAILS - SUCCESS",
                            label,
                            0,
                            false
                        );
                        
                       
                    })
                    .catch((error) => {

                        const errorReason = error && error.response && error.response.data && error.response.data.header && error.response.data.header.status && error.response.data.header.status.msg 
                        ||  error && error.data && error.data.header && error.data.header.status && error.data.header.status.msg 
                        || "Unable to check card for the reservation. Please try again or contact Front Desk";
    
                        const errorType = error && error.response && error.response.data && error.response.data.header && error.response.data.header.status && error.response.data.header.status.errorType 
                        ||  error && error.data && error.data.header && error.data.header.status && error.data.header.status.errorType ;
    
                        this.setState({ loaderInfo : {show: false, msg: ""},
                                       popupInfo : {show: true, msg: errorReason, primaryButtonText:"Retry", handlePrimaryButton: this.init.bind(this)}}
                        )
    
                        // based different failureCode do send analytics

                        // Send Analytics
                        let failedReason =  errorReason
                        let label = {
                            "dateTime": new Date,
                            "errorMessage": failedReason,
                            "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                            "Room": localStorage.getItem("room") || "",
                            "sourceApp": "guestJourneyApp",
                            "layoutTab": this.props.currentHomePage.tabName,
                            "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                        }

                        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CARD_UPDATE_API_FAILED, null, {
                            errorMessage: errorReason,
                            errorCode: errorType
                        })

                        this.props.sendAnalytics(
                            null,
                            this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                            "CREDIT CARD DETAILS - FAILED",
                            label,
                            0,
                            false
                        );
                    })
                     
                })
                .catch((error) => {

                    const errorReason = error && error.response && error.response.data && error.response.data.header && error.response.data.header.status && error.response.data.header.status.msg 
                    ||  error && error.data && error.data.header && error.data.header.status && error.data.header.status.msg 
                    || "Unable to check card for the reservation. Please try again or contact Front Desk";

                    const errorType = error && error.response && error.response.data && error.response.data.header && error.response.data.header.status && error.response.data.header.status.errorType 
                    ||  error && error.data && error.data.header && error.data.header.status && error.data.header.status.errorType ;

                    this.setState({ loaderInfo : {show: false, msg: ""},
                                   popupInfo : {show: true, msg: errorReason, primaryButtonText:"Retry", handlePrimaryButton: this.init.bind(this)}}
                    )

                    // based different failureCode do send analytics
                    // Send Analytics
                    let failedReason = errorReason
                    let label = {
                        "dateTime": new Date,
                        "errorMessage": failedReason,
                        "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
                        "Room": localStorage.getItem("room") || "",
                        "sourceApp": "guestJourneyApp",
                        "layoutTab": this.props.currentHomePage.tabName,
                        "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
                    }

                    this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.CHECKS_API_FAILED, null, {
                        errorMessage: errorReason,
                        errorCode: errorType
                    })

                    this.props.sendAnalytics(
                        null,
                        this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                        "CREDIT CARD DETAILS - FAILED",
                        label,
                        0,
                        false
                    );
                })
        
    };

    handleMessageEvent(e) {
        try {
            if (e.data && JSON.parse(e.data) && JSON.parse(e.data).action === "PLANET_RETURN_TO_APP") {
                console.log("Received message from iframe")
                this.performChecksCall(this.state.transactionId)
            }
        } catch (error) {
            // this.setState({popupInfo : {show: true, msg: "Something went wrong.", primaryButtonText:"Retry", handlePrimaryButton: this.init.bind(this)}})
            // console.log("error handling message eventlistener", error)
        }
    }

    attachExtraHandlers(secureFields){
 
        var cardContainer = document.getElementById('card-number-container');
        var cvvContainer = document.getElementById('cvv-container');
        var expiryContainer = document.getElementById('expiry-container');
        var expiryInput = document.getElementById('expiry');
    
        // Set focus to input fields when clicking containers
        cardContainer.addEventListener('click', function () {
          secureFields.focus('cardNumber');
        });
        cvvContainer.addEventListener('click', function () {
          secureFields.focus('cvv');
        });
    
        // Set class names when fields change
        secureFields.on('change', (data) => {
          console.log("data", data)
          // Fill expiration date date on card autocomplete
          if (data.event.type === 'autocomplete') {
            if (data.event.field === 'expiryYear') {
              var value = (expiryInput.value || '/')
              expiryInput.value = value.split('/')[0].trim() + ' / ' + data.event.value.slice(-2)
              return
            }
    
            if (data.event.field === 'expiryMonth') {
              var value = (expiryInput.value || '/')
              expiryInput.value = data.event.value + ' / ' + value.split('/')[1].trim()
              return
            }
          }
    
          var cardImage = cardContainer.querySelector('.secure-field--card-icon__recognized-card');
          cardContainer.classList.remove('secure-field__has-error');
          this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, cardNumber: { ...this.state.cardHolderDetails.cardNumber, errorMsg: null}}});

          cvvContainer.classList.remove('secure-field__has-error');
          this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, cvv: { ...this.state.cardHolderDetails.cvv, errorMsg: null}}});

          if (!data.fields.cardNumber.paymentMethod) {
            cardImage.src = 'layout_2/assests/card/card-empty.svg';
            cardContainer.classList.remove('secure-field__is-recognized');
          } else {
            cardImage.src = 'layout_2/assests/card/brands/' + data.fields.cardNumber.paymentMethod + '.svg';
            cardContainer.classList.add('secure-field__is-recognized');
          }
        })
    
        // Set class names on validate
        secureFields.on('validate',  (data) => {
          console.log("inside validate")
          if (data.fields.cardNumber.valid) {
            cardContainer.classList.remove('secure-field__has-error');
            this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, cardNumber: { ...this.state.cardHolderDetails.cardNumber, errorMsg: null}}});

          } else {
            cardContainer.classList.remove('secure-field__is-recognized');
            cardContainer.classList.add('secure-field__has-error');
            this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, cardNumber: { ...this.state.cardHolderDetails.cardNumber, errorMsg: `Invalid`}}});
          }
    
          if (data.fields.cvv.valid) {
            cvvContainer.classList.remove('secure-field__has-error');
            this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, cvv: { ...this.state.cardHolderDetails.cvv, errorMsg: null}}});

          } else {
            cvvContainer.classList.add('secure-field__has-error');
            this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, cvv: { ...this.state.cardHolderDetails.cvv, errorMsg: `Invalid`}}});

          }

          if(data.fields.cardNumber.valid && data.fields.cvv.valid){
            this.setState({loaderInfo : {show: true, msg: "Submitting..."}});
          }
        });
       
        document.getElementById("expiry").addEventListener('input', function () {
          expiryContainer.classList.remove('secure-field__has-error');
        });
      
        handleExpirationDate(document.getElementById("expiry"), "cvv", secureFields);
     
        expiryContainer.classList.add('secure-field__has-error');
  
    }

    async handleTransactionId(transactionId){
      console.log(transactionId,"transactionId")
      this.setState({loaderInfo : {show: true, msg: "Loading form..."}});
      await this.loadDatatransScript();

      var secureFields = new window.SecureFields();
      this.secureFields = secureFields;

      console.log("secureFields", secureFields)
      this.setState({transactionId});

      secureFields.init(
        transactionId ,
        {
          cardNumber: {
            placeholderElementId: 'card-number',
            inputType: 'tel'
          },
          cvv: {
            placeholderElementId: 'cvv-number',
            inputType: 'tel'
          }
        },
        {
          // options...
        }
      );

      this.attachExtraHandlers(secureFields)

      secureFields.on('ready', ()=>{
        this.setState({loaderInfo : {show: false, msg: ""}});
    
        // secureFields.setStyle('cardNumber', 'font-size: 100%; border-radius: 0; -webkit-appearance: none; padding: 0; outline: none');
        // secureFields.setStyle('cvv', 'font-size: 100%; border-radius: 0; -webkit-appearance: none; padding: 0; outline: none');
        secureFields.focus('cardNumber');
      });

  
      secureFields.on('success', (data)=> {
        this.setState({loaderInfo : {show: false, msg: ""}});
        console.log(data, "inside success")
        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.GOT_PAYMENT_GATEWAY_RESPONSE)

        if(data && data.cardInfo && data.cardInfo.brand) this.setState({cardTypeCode:data.cardInfo.brand})

        if (data.transactionId && data.redirect) {
          this.setState({iframeInfo:{show:true, loading: true, src: data.redirect}})
        } else if (data.transactionId ){
          this.performChecksCall(data.transactionId)
        } else {
            this.setState({popupInfo : {show: true, msg: "Something went wrong.", primaryButtonText:"Retry", handlePrimaryButton: this.init.bind(this)}})
        }
      });
  

    

    }

    getTransactionId(){
        this.setState({  
            loaderInfo : {show: true, msg: "Fetching transaction id..."},
            popupInfo : {show: false, handlePrimaryButton: null},
            iframeInfo : {show: false, loading: false} });

        clientConfigApi.post("/mobileCheckIn/cardValidation", {
            "header": {
                "sessionToken": localStorage.getItem("GuestJourneySessionToken"),
                "actionKey": "register"
            },
            "payload": {
                "confirmationNumber": this.props.confirmationNumber,
                "developmentEnvironment": CARD_DEMO ? true : undefined
            }
        }).then(response => {
            if(response.status != 200) throw response
            if(!response.data.payload.tokenStr) throw {};

            this.handleTransactionId(response.data.payload.tokenStr)
            this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.REGISTER_API_SUCCESS)

        }).catch(error => {

            this.setState({loaderInfo : {show: false, msg: ""}});
            const errorMsg = error && error.data && error.data.header && error.data.header.status && error.data.header.status.msg 
            ||  error && error.response && error.response.data && error.response.data.header && error.response.data.header.status && error.response.data.header.status.msg  
            || "Unable to fetch transaction id.";

            this.setState({popupInfo : {show: true, msg: errorMsg, primaryButtonText:"Retry", handlePrimaryButton: this.init.bind(this)}})

            let failedReason = errorMsg
            let label = {
                ...getDefaultAnalyticsLabel({ appVersion: this.props.installedAppVersion ? `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})` : "" }),
                "dateTime": new Date,
                "errorMessage": failedReason, "layoutTab": this.props.currentHomePage.tabName,
                "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
            }

            this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.REGISTER_API_FAILED, null, { "errorMessage": errorMsg})

            this.props.sendAnalytics(
                null,
                this.props.currentWidgetObj.widgetType || "Mobile Check-in",
                "CREDIT CARD DETAILS - FAILED",
                label,
                0,
                false
            );
        })
    }

    handleSubmit=()=>{
        console.log(this.state.cardHolderDetails);

        for(const field of ["name"]){
            console.log(field, this.state.cardHolderDetails, this.state.cardHolderDetails[field] )
            if (!this.state.cardHolderDetails[field].value) {
                this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, [field]: { ...this.state.cardHolderDetails[field], errorMsg: `Please enter ${field}`}}});
                return;
            }
        }

        if (!document.getElementById('expiry').value) {
            this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, expiry: { ...this.state.cardHolderDetails.expiry, errorMsg: "Please enter card's expiry." }}});
            return;
        }

        for(const field of ["address","pincode","email",]){
            console.log(field, this.state.cardHolderDetails, this.state.cardHolderDetails[field] )
            if (!this.state.cardHolderDetails[field].value) {
                this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, [field]: { ...this.state.cardHolderDetails[field], errorMsg: `Please enter ${field}`}}});
                return;
            }
        }

        const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailPattern.test(this.state.cardHolderDetails.email.value)) {
            this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, email: { ...this.state.cardHolderDetails.email, errorMsg: `Please enter valid email.`}}});
            return;
        }
 
        if (!(/^[a-zA-Z0-9, .]+$/.test(this.state.cardHolderDetails.address.value))) {
            this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, address: { ...this.state.cardHolderDetails.address, errorMsg: "Please note that only English letters and numbers are accepted for the address"}}});
            return;
        }


        // if (CARD_DEMO) {
        //     this.props.showLoader(true);
        //     setTimeout(() => {
        //         this.props.showLoader(false);
        //         this.setState({ cardVerified: true })
        //         this.props.setCardStatusPopupProps({
        //             cardStatus: true,
        //             statusTitle: 'Success',
        //             statusMessage1: 'Card verified successfully',
        //             statusMessage2: 'Please proceed to next steps'
        //         })
        //         this.props.showCardVerified({ firstName: this.state.firstName, lastName: this.state.lastName, address: this.state.address, phone: this.state.phoneNumber, email: this.state.email })
        //         localStorage.setItem('cardVerfied', true)

        //         let label = {
        //             "dateTime": new Date,
        //             "appVersion": `${this.props.installedAppVersion}(${this.props.installedAppBuildNo})`,
        //             "Room": localStorage.getItem("room") || "",
        //             "sourceApp": "guestJourneyApp",
        //             "layoutTab": this.props.currentHomePage.tabName,
        //             "pageName": "CREDIT CARD DETAILS", "widgetSessionId": localStorage.getItem("checkinSessionToken")
        //         }
        //         this.props.sendAnalytics(
        //             null,
        //             this.props.currentWidgetObj.widgetType || "Mobile Check-in",
        //             "CREDIT CARD DETAILS - SUCCESS",
        //             label,
        //             0,
        //             false
        //         );

        //     }, 1500)
        //     return;
        // }

 
        var result
        try {
          result = getExpirationDateObject(document.getElementById('expiry').value)
        } catch {
          // nothing to catch here
        }
        try{
          console.log( {      
            "email": this.state.cardHolderDetails.email,
            "cardholderName": this.state.cardHolderDetails.name,
            "billAddrLine1": this.state.cardHolderDetails.address,
            "billAddrPostCode": this.state.cardHolderDetails.pincode,
          }
          )
          if (result) {
            this.secureFields.submit({
              expm: result.expm,
              expy: result.expy,
              "3D": { 
                "cardholder": {      
                    "email": this.state.cardHolderDetails.email.value,
                    "cardholderName": this.state.cardHolderDetails.name.value,
                    "billAddrLine1": this.state.cardHolderDetails.address.value,
                    "billAddrPostCode": this.state.cardHolderDetails.pincode.value,
                }}
              }
            );
            return;
          }
        }catch(e){
          console.log("inside catch")
          console.log(e.message)
        }

    }

    handleInputChange(e){
       
        const { name:fieldName, value:fieldValue } = e.target;
        console.log(fieldName, fieldValue);

        if (fieldName === "name") {
            if (/\d/.test(fieldValue)) {
                this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, name: { ...this.state.cardHolderDetails.name, errorMsg: "Name cannot contain digits" }}});
                return; // don't update state with value
            }
        }

        this.setState({ cardHolderDetails: {...this.state.cardHolderDetails, [fieldName]: { value: fieldValue , errorMsg: null }}});

    };

    init(){
      this.setState({loaderInfo : {show: false, msg: ""},
                    popupInfo : {show: false, msg:"" , primaryButtonText:"", handlePrimaryButton: null},
                    iframeInfo : {show: false, loading: false},
                    transactionId: null,
                    verifyAttempts: this.state.verifyAttempts + 1,
                    cardHolderDetails: {
                        name:{value:"", errorMsg: null},
                        expiry:{ value:"", errorMsg: null},
                        email:{value:"", errorMsg: null},
                        address:{value:"", errorMsg: null},
                        pincode:{value:"", errorMsg: null},
                        cvv: {  errorMsg: null},
                        cardNumber: { errorMsg: null},
                        cardTypeCode:null
                    }
                    })

      this.getTransactionId();
      
    }
    
    componentDidMount() {
        console.log("Planet mounted")
        this.loadDatatransScript();
        this.sendIntermediaryCardValidationGA(cardValidationIntermediaryEvents.LANDED_ON_CARD_DETAILS_PAGE)
        this.init()
    }
    
    componentDidUpdate(prevProps, prevState){
        if(prevState.verifyAttempts != this.state.verifyAttempts){
            console.log("verifyAttempts", this.state.verifyAttempts)

            const maxRetries = this.props.guestValidationMaxRetry || 3;

            if (this.state.verifyAttempts > maxRetries + 1) {
                this.setState({popupInfo : {show: true, msg: "Maximum card verification attempts reached", primaryButtonText:"Close", handlePrimaryButton: this.props.backBtn}})
                return;
            }
        }

        if(prevState.popupInfo.show != this.state.popupInfo.show && this.state.popupInfo.show ){
            this.props.setShowCustomPopup(true, {
                htmlTagId: "",
                title: "",
                heading: this.state.popupInfo.msg,
                primaryButtonText: this.state.popupInfo.primaryButtonText,
                primaryOnClick: () => { this.state.popupInfo.handlePrimaryButton();  this.props.setShowCustomPopup(false)},
            })
        }


    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleMessageEvent);
    }


    render() {
        const { t } = this.props
        return (

            <div className='planet-container-parent'>

                {this.state.IFrameLoading && <div class="loader-ring"></div>}
               
                    <div>
                        <header className="inner-pages w-footer subpages">
                            <a className="button-back" onClick={this.props.backBtn}></a>
                            <div className="heading align-center">
                                <div class="splash-brand">
                                    <img src={`${CMSPath}${this.props.logo}`} />
                                </div>
                             </div>
                        </header>
                        <section className="widgets padding-0 margin-0 container-bg">

                            <div class="widget-header widget-header-checkin-inner">
                              
                                <div class="widget-header-title">{t("check_in.verify_card_heading")}</div>
                                <div class="widget-header-subtitle">{t("check_in.verify_card_subheading")}</div>
                               
                            </div>

                            {this.state.iframeInfo.show ?
                                <>
                                    {this.state.IFrameLoading && <div class="loader-ring"><img src="layout_2/assests/loader.png" /></div>}

                                    <iframe frameborder="0" onLoad={() => {
                                        scrollToTop();
                                        this.setState({iframeInfo:{ ...this.state.iframeInfo, loading: false}})
                                        $(".planet-container").attr("style", "width: 100%; height: 33rem")
                                    }} style={{ width: 0, height: 0 }} ref={this.iframeRef} className='planet-container' src={this.state.iframeInfo.src}></iframe>

                                    {DEMO && <input class="card-skip" onClick={() => this.props.next()} type="submit" value="Skip" style={{ marginTop: '1rem', color: "#000", backgroundColor: "#fff" }} />}
                                </>
                                :
                            <div className="widgets" style={{ padding: "0 1rem" }}>
                                <div className="row padding-top-1 padding-bottom-0 padding-right-1 padding-left-1">
                                    <h2>{t('check_in.booking_details')}</h2>
                                </div>
                                {!(localStorage.getItem('cardVerfied') == 'true') ?
                                     <div className="form-window yet-to-verify">
                                        <div className="form-window-heading">
                                            {t('check_in.card_details')}
                                        </div>
                                        <div className='row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1'>
                                            <p>{CARD_CAN_BE_CHARGED ? t('check_in.enter_card_details') : "Please enter your card details."} </p>
 
                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label htmlfor="name">Name On Card <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="name"
                                                    autoComplete='given-name'
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.cardHolderDetails.name.value}
                                                    type="text"
                                                    placeholder="John Doe" />
                                                {this.state.cardHolderDetails.name.errorMsg && (
                                                    <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                        {this.state.cardHolderDetails.name.errorMsg}
                                                    </div>
                                                )}
                                            </div>

                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <div id="card-number-container"
                                                    class="secure-field secure-field__input secure-field__base secure-field__has-actions secure-field__has-card-icon">
                                                    <label htmlfor="card-number">Card Number</label>
                                                    <div class="secure-field--input-container" 
                                                    style={{height: "40px"}}
                                                    >
                                                        <div class="secure-field--input" id="card-number" style={{height: "100%"}} ></div>
                                                        <div class="secure-field--actions">
                                                        <span class="secure-field--action secure-field--action__card-icon">
                                                        <span class="secure-field--action-card-wrap">
                                                            <img class="secure-field--card-icon secure-field--card-icon__empty" src="layout_2/assests/card/card-empty.svg"/>
                                                            <img class="secure-field--card-icon secure-field--card-icon__error" src="layout_2/assests/card/card-error.svg"/>
                                                            <img class="secure-field--card-icon secure-field--card-icon__recognized-card"
                                                            src="layout_2/assests/card/card-recognized.svg"/>
                                                        </span>
                                                        </span>
                                                    </div>
                                                    </div>
                                                    {this.state.cardHolderDetails.cardNumber.errorMsg && (
                                                                <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                                    {this.state.cardHolderDetails.cardNumber.errorMsg}
                                                                </div>
                                                    )}
                                                    
                                                </div>
                                            </div>

                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <div style={{
                                                    // marginTop: "20px",
                                                    display: "flex",
                                                    justifyContent: "space-between",
                                                    gap: "30px"}}>
                                                
                                                    <div id="expiry-container"
                                                        class="secure-field secure-field__input secure-field__base secure-field__has-actions secure-field__has-card-icon"
                                                        style={{maxWidth: "150px",
                                                            minWidth: "100px",
                                                            flexShrink: "1"}}>
                                                        <label htmlfor="expiry">Expiration Date</label>
                                                            <div class="secure-field--input-container" style={{
                                                                // height: "40px",
                                                                flexDirection: "column"}}>
                                                                <input id="expiry" name="expiry" type="tel" maxlength="7" placeholder="MM / YY" class="secure-field--input"
                                                                    style={{height: "40px", outline: "none", fontSize: "100%"}} autocomplete="cc-exp" value={this.state.cardHolderDetails.expiry.value} onChange={(e) => this.handleInputChange(e)} />
                                                                <div class="secure-field--actions" style={{height: "40px"}}>
                                                                    <span class="secure-field--action secure-field--action__card-icon">
                                                                    <span class="secure-field--action-card-wrap">
                                                                        <img class="secure-field--card-icon secure-field--card-icon__error" src="layout_2/assests/card/cvc-error.svg"/>
                                                                    </span>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                            {this.state.cardHolderDetails.expiry.errorMsg && (
                                                                <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                                    {this.state.cardHolderDetails.expiry.errorMsg}
                                                                </div>
                                                            )}
                                                       
                                                        
                                                    </div>
                                                
                                                    <div id="cvv-container"
                                                        class="secure-field secure-field__input secure-field__base secure-field__has-actions secure-field__has-card-icon"
                                                        style={{   maxWidth: "150px",
                                                                minWidth: "120px",
                                                                flexShrink: "1",
                                                                    flexGrow: 1}}>
                                                        <label htmlfor="cvv-number">CVV</label>
                                                        <div class="secure-field--input-container"  style={{
                                                            height: "40px", 
                                                             flexDirection: "column"}}>
                                                        <div class="secure-field--input" id="cvv-number" style={{height: "100%"}} ></div>
                                                        <div class="secure-field--actions">
                                                            <span class="secure-field--action secure-field--action__card-icon">
                                                            <span class="secure-field--action-card-wrap">
                                                                <img class="secure-field--card-icon secure-field--card-icon__empty" src="layout_2/assests/card/cvc-empty.svg"/>
                                                                <img class="secure-field--card-icon secure-field--card-icon__error" src="layout_2/assests/card/cvc-error.svg"/>
                                                            </span>
                                                            </span>
                                                        </div>
                                                        </div>
                                                        {this.state.cardHolderDetails.cvv.errorMsg && (
                                                                <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                                    {this.state.cardHolderDetails.cvv.errorMsg}
                                                                </div>
                                                        )}
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <div style= {{
                                                    // marginTop: "20px",
                                                     display: "flex", justifyContent: "space-between", gap: "30px", width: "100%" }} >
                                                
                                                    <div id="address-container"
                                                        class="secure-field secure-field__input secure-field__base secure-field__has-actions secure-field__has-card-icon"
                                                        style={{  flexShrink: 1, flexGrow: 3, minWidth: "100px"}}>
                                                        <label htmlfor="address">Address</label>
                                                        <div class="secure-field--input-container" style={{  flexDirection: "column"}}>
                                                        <input name="address" id="address" type="text" placeholder="123 street" 
                                                            style={{height: 
                                                                
                                                                "40px", outline: "none", fontSize: "100%"}} value={this.state.cardHolderDetails.address.value} onChange={(e) => this.handleInputChange(e)}/>
                                                            {this.state.cardHolderDetails.address.errorMsg && (
                                                                <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                                    {this.state.cardHolderDetails.address.errorMsg}
                                                                </div>
                                                            )}
                                                        </div>
                                                    </div>

                                            
                                                    <div id="pincode-container"
                                                    class="secure-field secure-field__input secure-field__base secure-field__has-actions secure-field__has-card-icon"
                                                    style={{   flexShrink: 1, flexGrow: 1 }}>
                                                    <label htmlfor="pincode">Pincode</label>
                                                    <div class="secure-field--input-container" style={{
                                                        // height: "40px", 
                                                         flexDirection: "column"}}>
                                                        <input name="pincode" id="pincode" type="number" placeholder="11111" class="secure-field--input"
                                                        style={{height: "40px", outline: "none", fontsize: "100%"}}  value={this.state.cardHolderDetails.pincode.value} onChange={(e) => this.handleInputChange(e)}/>
                                                        {this.state.cardHolderDetails.pincode.errorMsg && (
                                                            <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                                {this.state.cardHolderDetails.pincode.errorMsg}
                                                            </div>
                                                        )}
                                                        
                                                    </div>
                                                    </div>

                                                </div>
                                            </div>

                                            <div className="form-row margin-bottom-1 margin-right-1">
                                                <label htmlfor="email">Email <span style={{ color: "red" }}>*</span></label>
                                                <input
                                                    name="email"
                                                    autoComplete='email'
                                                    onChange={(e) => this.handleInputChange(e)}
                                                    value={this.state.cardHolderDetails.email.value}
                                                    placeholder="Email"
                                                    type="email"
                                                />
                                                {this.state.cardHolderDetails.email.errorMsg && (
                                                    <div style={{ color: "red", fontSize: "0.875rem", marginTop: "0.25rem" }}>
                                                        {this.state.cardHolderDetails.email.errorMsg}
                                                    </div>
                                                )}
                                            </div>
                                   

                                            <div className="form-controls">
                                                <button disabled={this.state.iframeInfo.show} className="primary w-100" onClick={this.handleSubmit}>Verify Card</button>
                                            </div>
                                            {DEMO && <input class="card-skip" onClick={() => this.props.next()} type="submit" value="Skip" style={{ marginTop: '1rem', color: "#000", backgroundColor: "#fff" }} />}

                                        </div>
                                    </div>
                                    :
                                    <div class="form-window verified">
                                        <div class="form-window-heading">
                                            Card verified
                                        </div>
                                        <div class="row padding-top-1 padding-bottom-1 padding-right-1 padding-left-1">
                                            <div class="form-row margin-bottom-1">
                                                <p>Your card was successfully verified.</p>
                                                <p>Tap on NEXT to proceed</p>
                                            </div>
                                            <div class="form-controls">
                                                <button className="primary w-100" onClick={() => this.props.next()}>{t('check_in.next')}</button>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            }

                            {this.state.loaderInfo.show && <Loader close={ this.props.backBtn } displayMsg={this.state.loaderInfo.msg} />}

                        </section>
                    </div>
            </div>
        );
    }
}

const mapStateToProps = state => {
    return {
        cardChecksData: state.store2.cardChecksData,
        guestDetail: state.store.home.guestDetails,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
        logo: state.store.home.currentDuration.brandingInfo ?
            state.store.home.currentDuration.brandingInfo.hotelLogoImageUrl : "",
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentWidgets: state.store.sideNavBar.currentWidget,
        currentHomePage: state.store2.currentHomePage,
        currentWidgetObj: state.store.sideNavBar.currentWidget,
        checkInAddress: state.store2.checkInAddress,
        guestValidationMaxRetry: state.store2.cardChecksData.guestValidationMaxRetry,
    }
}

export default connect(mapStateToProps, {
    setCardStatusPopupProps,
    popupOpenClose,
    sendAnalytics,
    setCheckInAddress,
    setCheckinCurrentPageName,
    setShowCustomPopup
})(withTranslation('translations')(Planet));